import { useMemo } from 'react';
import { Button } from 'react-bootstrap';

import catalystLogoImg from '@assets/images/catalyst-logo.png';
import myomeLogoImg from '@assets/images/full_logo.svg';
import { POWERED_BY_BRAND } from '@constants/constants';
import { CATALYST_CAMPAIGN_CODE } from '@constants/clinician';
import { Campaign } from '@customTypes/campaign';

import './OrderingOptionSelect.scss';

interface OrderingOptionSelectProps {
  onSelect: (campaign: Campaign | null) => void;
  campaigns: Campaign[];
}

export default function OrderingOptionSelect(props: OrderingOptionSelectProps) {
  const { campaigns, onSelect } = props;

  const campaignOptions = useMemo(
    () => [
      ...campaigns,
      {
        campaign_code: '',
        name: 'My OME',
        description: 'General Ordering',
      } as Campaign,
    ],
    [campaigns],
  );

  return (
    <div className='d-flex flex-column flex-wrap flex-md-row gap-4 ordering-options'>
      {campaignOptions.map(campaign => (
        <OrderingOption onSelect={onSelect} key={campaign.name} campaign={campaign} />
      ))}
    </div>
  );
}

interface OrderingOptionProps {
  onSelect: (campaign: Campaign | null) => void;
  campaign: Campaign;
}

const OrderingOption = (props: OrderingOptionProps) => {
  const { campaign, onSelect } = props;

  const isCatalyst = useMemo(() => campaign.campaign_code === CATALYST_CAMPAIGN_CODE, [campaign.campaign_code]);
  const isGeneric = useMemo(
    () => !!campaign.campaign_code && campaign.campaign_code !== CATALYST_CAMPAIGN_CODE,
    [campaign.campaign_code],
  );

  return (
    <Button
      variant='link'
      className={`d-flex flex-column ordering-option ${isCatalyst && 'catalyst'}`}
      onClick={() => onSelect(campaign.campaign_code ? campaign : null)}
      data-testid={`ordering-option-${campaign.campaign_code || 'general'}`}
    >
      <div className='ordering-option-content'>
        {isGeneric && <span className='campaign-name'>{campaign.name}</span>}
        {!isCatalyst && !isGeneric && <img src={myomeLogoImg} alt='MyOme logo' height={60} />}
        {isCatalyst && <img src={catalystLogoImg} alt='Catalyst Logo' height={50} />}
      </div>
      <div className='text-uppercase text-center text-white ordering-option-footer'>
        {isGeneric
          ? campaign.description || POWERED_BY_BRAND
          : isCatalyst
            ? 'Partnership Ordering'
            : 'General Ordering'}
      </div>
    </Button>
  );
};
